import { useMemo } from "react";
import { useWindowSize } from "./useWindowSize";

/**
 * Custom hook to determine mobile screen breakpoints
 */
export const useIsMobile = () => {
  const { width } = useWindowSize();
  const isMobile = useMemo(() => width <= 720, [width]);
  return isMobile;
};
